<template>
  <div class="page">
    <div style="background-color: lightgrey" class="option">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1" title="查询条件">
          <!--          <van-cell-group>-->
          <van-field v-model="queryFormModel.id" :colon="true" label="ID" placeholder="请输入ID" type="digit"/>
          <van-field v-model="queryFormModel.name" :colon="true" label="名称" placeholder="请输入名称"/>
          <van-field
              :colon="true"
              :value="queryFormModel.sex"
              clickable
              label="性别"
              placeholder="请选择性别"
              readonly
              @click="openPicker(sexColumn,(value)=>{queryFormModel.sex = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.grade"
              clickable
              label="等级"
              placeholder="请选择等级"
              readonly
              @click="openPicker(gradeColumn,(value)=>{queryFormModel.grade = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.status"
              clickable
              label="在线状态"
              placeholder="请选择在线状态"
              readonly
              @click="openPicker(statusColumn,(value)=>{queryFormModel.status = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isDisabled"
              clickable
              label="上架状态"
              placeholder="请选择上架状态"
              readonly
              @click="openPicker(isDisabledColumn,(value)=>{queryFormModel.isDisabled = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isHide"
              clickable
              label="显示状态"
              placeholder="请选择显示状态"
              readonly
              @click="openPicker(isHideColumn,(value)=>{queryFormModel.isHide = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.isVerified"
              clickable
              label="实名状态"
              placeholder="请选择实名状态"
              readonly
              @click="openPicker(isVerifiedColumn,(value)=>{queryFormModel.isVerified = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.requireVerify"
              clickable
              label="需要实名"
              placeholder="请选择是否需要实名"
              readonly
              @click="openPicker(requireVerifyColumn,(value)=>{queryFormModel.requireVerify = value})"
          />
          <van-field
              :colon="true"
              :value="queryFormModel.randomOrderSwitch"
              clickable
              label="随机单开关"
              placeholder="请选择随机单开关"
              readonly
              @click="openPicker(randomOrderSwitchColumn,(value)=>{queryFormModel.randomOrderSwitch = value})"
          />
          <van-cell
              v-if="$hasFeature('recommend_clerk')"
              clickable
              title="只看推荐的店员"
              @click="queryFormModel.isRecommend = !queryFormModel.isRecommend"
          >
            <template #right-icon>
              <van-checkbox ref="checkboxes" v-model="queryFormModel.isRecommend"/>
            </template>
          </van-cell>
          <van-cell
              clickable
              title="只看置顶的店员"
              @click="queryFormModel.isTop = !queryFormModel.isTop"
          >
            <template #right-icon>
              <van-checkbox ref="checkboxes" v-model="queryFormModel.isTop"/>
            </template>
          </van-cell>
          <van-cell
              clickable
              title="只看固定等级的店员"
              @click="queryFormModel.isFixGrade = !queryFormModel.isFixGrade"
          >
            <template #right-icon>
              <van-checkbox ref="checkboxes" v-model="queryFormModel.isFixGrade"/>
            </template>
          </van-cell>
          <div class="flex justify-center margin-tb-xs">
            <van-button size="large" type="info" @click="onLoad(true)">查询</van-button>
          </div>
          <!--          </van-cell-group>-->
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-popup v-model="picker.show" position="bottom" round>
      <van-picker
          :columns="picker.columns"
          show-toolbar
          @cancel="onPickerCancel"
          @confirm="onPickerConfirm"
      />
    </van-popup>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="list"
    >
      <div v-for="(clerk,index) in list" :key="index" class="listItem">

        <div class="clerkInfo">
          <img :src="clerk.avatarUrl" @click="previewPhoto([clerk.avatarUrl],0)" class="avatar"/>
          <div class="infoCore">
            <div class="header">
              <div class="align-center" style="margin-bottom: 13px">
                <div class="clerkName">{{ clerk.name }}</div>
                <div class="age-sex" :style="clerk.sex == 1 ? 'background: #84C6FF' : 'background: #FFA0B3'">
                  <img :src="'/static/images/default/clerk-manage/' + (clerk.sex == 1 ? 'sex1.png' : 'sex2.png')" style="width: 8px; height: 8px; margin-right: 2px"/>
                  <div>{{ clerk.age }}</div>
                </div>
                <div class="regionNames">
                  {{clerk.regionNames != null && clerk.regionNames.length > 0 ?
                    clerk.regionNames.join('-') : '' }}
                </div>
                <div class="share align-center" @click="qrcodeClick(clerk.id)">
                  <div class="iconfont icon-dianyuanguanli-fenxiang" style="color: var(--primary-color); margin-right: 3px"></div>
                  分享
                </div>
              </div>
              <div class="align-center">
                <div>ID {{ clerk.id }}</div>
                <div>
                  <div class="isVerified">{{clerk.isVerified? '实名姓名：' + clerk.realName : '未实名'}}</div>
                  <div v-if="clerk.isVerified" class="isVerified">实名年龄：{{ clerk.realAge }}</div>
                </div>
                <div class="audio">
                  <span v-if="clerk.audioUrl == null || clerk.audioUrl == ''">未上传录音</span>
                  <van-button v-else class="btn-play-audio" color="#666" plain size="mini"
                              @click.stop="playAudio(clerk.id, clerk.audioUrl)">
                    <div class="flex align-center">
                      <img :src="player.id == clerk.id ? '/static/images/default/clerk-manage/audio2.png' : '/static/images/default/clerk-manage/audio1.png'" style="width: 6px; margin-right: 6px;">
                      {{ player.id == clerk.id ? '停止' : '播放' }}
                    </div>
                  </van-button>
                </div>
              </div>
            </div>
            <div class="signature">{{clerk.itemType === $store.state.ClerkItemTypeEnum.EMOTION.value ? '人生寄语' : '个性签名'}}：{{ clerk.signature }}</div>
            <div class="tags">
              标签：
              <div class="tagsItem" v-for="(item, index) in clerk.tags" :key="index">{{item}}{{ index == (clerk.tags.length - 1) ? '' : '、'}}</div>
            </div>
            <div class="photos">
              <img v-for="(pic,index) in clerk.photoUrls" :key="index" :src="pic" @click="previewPhoto(clerk.photoUrls,index)"
                   class="photoItem"/>
            </div>
          </div>
        </div>

        <div style="display: flex; align-items: center; margin-bottom: 7px; font-size: 13px; flex-wrap: wrap; padding-bottom: 11px; border-bottom: 1px solid #F5F5F5">
          <div class="flex" style="padding: 5px 0; margin-right: 15px">
            <span class="label">等级：</span>
            <template v-if="hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('grade'))">
              <div class="flex align-center" @click="openPicker(gradeColumn,(value)=>{updateStatus(clerk.id,'grade',mapGrade(value))},()=>{})">
                <span>{{ $store.state.ClerkGradeMap[clerk.grade] }}</span>
                <img src="/static/images/default/clerk-manage/down.png" style="width: 8px; margin-left: 4px;"/>
              </div>
            </template>
            <template v-else>
              <div class="flex align-center">
                <span>{{ $store.state.ClerkGradeMap[clerk.grade] }}</span>
              </div>
            </template>
          </div>
          <div class="flex" v-if="$hasFeature('clerk_group')" style="padding: 5px 0; margin-right: 15px">
            <span class="label">分组：</span>
            <span>{{ clerk.groupName }}</span>
          </div>
          <div class="flex" style="padding: 5px 0">
            <span class="label">是否需要实名：</span>
            <template v-if="hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('requireVerify'))">
              <div class="flex align-center" @click="openPicker(requireVerifyColumn,(value)=>{updateStatus(clerk.id,'requireVerify',requireVerifyMap[value])},()=>{})">
                <template v-if="clerk.requireVerify === true"><span>需要</span></template>
                <template v-else-if="clerk.requireVerify === false"><span>不需要</span></template>
                <template v-else><span>跟随店铺设置</span></template>
                <img src="/static/images/default/clerk-manage/down.png" style="width: 8px; margin-left: 4px;"/>
              </div>
            </template>
            <template v-else>
              <div class="flex align-center">
                <template v-if="clerk.requireVerify === true"><span>需要</span></template>
                <template v-else-if="clerk.requireVerify === false"><span>不需要</span></template>
                <template v-else><span>跟随店铺设置</span></template>
              </div>
            </template>
          </div>
        </div>

        <div class="switchBox">
          <div class="switchItem">
            <van-switch active-color="var(--primary-color)" :disabled="!(hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('status')))" :value="clerk.status === 1" size="18" @input="s=>{updateStatus(clerk.id,'status',s?1:2)}"/>
            <span class="label">在线</span>
          </div>
          <div class="switchItem">
            <van-switch active-color="var(--primary-color)" :disabled="!(hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('isDisabled')))" :value="!clerk.isDisabled" size="18" @input="s=>{updateStatus(clerk.id,'isDisabled',!s)}"/>
            <span class="label">上架</span>
          </div>
          <!--              <div v-if="$hasFeature('recommend_clerk')" class="flex align-center" >-->
          <!--                <span class="label">推荐：</span>-->
          <!--                <van-switch :disabled="!(hasAdmin || hasLeader)" :value="clerk.isRecommend" size="18" @input="s=>{updateStatus(clerk.id,'isRecommend',s)}"/>-->
          <!--              </div>-->
          <div class="switchItem">
            <van-switch active-color="var(--primary-color)" :disabled="!(hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('isHide')))"  :value="!clerk.isHide" size="18" @input="s=>{updateStatus(clerk.id,'isHide',!s)}"/>
            <span class="label">显示</span>
          </div>
          <!--              <div class="flex align-center">-->
          <!--                <span class="label">置顶：</span>-->
          <!--                <van-switch :disabled="!hasAdmin" :value="clerk.isTop" size="18" @input="s=>{updateStatus(clerk.id,'isTop',s)}"/>-->
          <!--              </div>-->
          <div class="switchItem">
            <van-switch active-color="var(--primary-color)" :disabled="!(hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('randomOrderSwitch')))" :value="clerk.randomOrderSwitch" size="18"
            @input="s=>{updateStatus(clerk.id,'randomOrderSwitch',s)}"/>
            <span class="label">随机单</span>
          </div>
          <div class="switchItem">
            <van-switch active-color="var(--primary-color)" :disabled="!(hasAdmin || (hasLeader && $LeaderPermission.modifiableClerkAttr.includes('isFixGrade')))" :value="clerk.isFixGrade" size="18"
                        @input="s=>{updateStatus(clerk.id,'isFixGrade',s)}"/>
            <span class="label">固定等级</span>
          </div>
        </div>
        <div class="remark" @click="clickRemark(index,clerk.remark,true,clerk.id)">
          备注：{{ clerk.remark }}
          <img src='/static/images/default/clerk-manage/edit.png' style="width: 13px; height: 13px; margin-left: 6px">
        </div>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-top: 10px;" v-if="hasLeader && $LeaderPermission.modifiableClerkAttr.includes('onBoardingAndResign')">
          <div class="created"> 创建时间:{{ formatTime(clerk.createTime) }} </div>
          <div class="align-center" style="font-size: 15px;" @click="initiateResignTest(clerk.id,clerk.name)">
            <img src="/static/images/default/clerk-manage/job.png" style="width: 13px; height: 15px; margin-right: 4px"/>
            发起离职
          </div>
        </div>
      </div>
    </van-list>
    <van-dialog
        v-model="initiateResign.show"
        show-cancel-button="show-cancel-button"
        title="发起离职"
        :before-close="showConfirmButton"
    >
      <div class="box">
        <span class="title">离职店员</span>
        <div class="right-box">{{clerkName}}</div>
      </div>
      <div class="box">
        <span class="title">离职类型</span>
        <div class="right-box">
          <van-radio-group v-model="radio" direction="horizontal" property="lizhi">
          <van-radio name="true">主动</van-radio>
          <van-radio name="false">被动</van-radio>
        </van-radio-group>
        </div>
      </div>
      <div class="box">
        <span class="title">离职原因</span>
        <div class="right-box">
          <van-field
              v-model="message"
              rows="2"
              autosize
              type="textarea"
              maxlength="100"
              placeholder="请输入内容"
              show-word-limit
              class="input-style"
          />
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="promotionDialog.show" title="分享">
      <div class="qrbox">
        <vue-qr :logoSrc="promotionDialog.loge" :text="promotionDialog.url"
                ref="Qrcode"
                width="300"
                :key="promotionDialog.key"
                :correctLevel="0"
                :logoScale="0.22"
                :margin="50"
                :size="900"
                :logoCornerRadius="15"
                :logoMargin="10">
        </vue-qr>
      </div>
      <div style="width: 100%;text-align: center;padding-bottom: 5px;font-size: 14px;color: #999999">请长按保存二维码</div>
      <van-button class="qrbox" plain color="#1989fa" size="mini" @click="copyClick(promotionDialog.url)">
        <span style="margin: 8px;font-size: 14px;">复制链接</span>
      </van-button>
    </van-dialog>
    <!-- 修改备注 -->
    <van-dialog v-model="updateRemarkDialog.show" title="修改备注" show-cancel-button :beforeClose="onUpdateRemarkDialogClose">
      <div class="padding-top-sm">
        <van-field v-model="updateRemarkDialog.remark"
                   placeholder="请输入备注"
                   maxlength="100"
                   style="background: #f5f5f5;"/>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import VueQr from 'vue-qr'
import {
  Button,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Dialog,
  DropdownItem,
  DropdownMenu,
  Field,
  Icon,
  ImagePreview,
  List,
  Picker,
  Popup,
  Switch,
  Tag,
  Toast,
  RadioGroup, Radio
} from 'vant';
import {listClerk} from "@/api/leader/clerk";
import moment from "moment";
import _ from 'lodash'
import {
  updateGrade,
  updateIsDisabled, updateIsFixGrade,
  updateIsHide,
  updateIsRecommend,
  updateIsTop,
  updateRandomOrderSwitch, updateRequireVerify,
  updateStatus, shareInterface,
  updateClerkRemark, addClerkResign
} from "@/api/clerk";
import {getShopSetting} from "@/api/global";

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(ImagePreview)
Vue.use(List)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(Icon)
Vue.use(Tag);
Vue.use(Dialog)
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  name: "clerk-manage",
  props: {},
  components: {
    VueQr
  },
  computed: {
    hasAdmin(){
      return this.$hasRolesAny('admin');
    },
    hasLeader(){
      return this.$hasRolesAny('leader');
    },
    sexColumn() {
      return this.mapEnumToColumn(this.$store.state.ClerkSexEnum)
    },
    gradeColumn() {
      return Object.values(this.$store.state.ClerkGradeMap)
    },
    statusColumn() {
      return this.mapEnumToColumn(this.$store.state.ClerkStatusEnum)
    },
    isDisabledColumn() {
      return Object.keys(this.isDisabledMap)
    },
    isHideColumn() {
      return Object.keys(this.isHideMap)
    },
    isVerifiedColumn() {
      return Object.keys(this.isVerifiedMap)
    },
    requireVerifyColumn() {
      return Object.keys(this.requireVerifyMap)
    },
    randomOrderSwitchColumn() {
      return Object.keys(this.randomOrderSwitchMap)
    }
  },
  data() {
    return {
      promotionDialog: {
        show: false,
        url: null,
        name: null,
        loge: null,
        key: null,
      },
      updateRemarkDialog: {
        show: false,
        remark: null,
        id: null,
        index: null
      },
      queryFormModel: {
        id: null,
        name: null,
        sex: null,
        grade: null,
        group: null,
        status: null,
        isDisabled: null,
        isRecommend: null,
        isTop: null,
        isHide: null,
        isVerified: null,
        requireVerify: null,
        randomOrderSwitch: null,
        isFixGrade: null
      },
      isDisabledMap: {
        '上架': false,
        '下架': true
      },
      isHideMap: {
        '显示': false,
        '隐藏': true
      },
      isVerifiedMap: {
        '已实名': true,
        '未实名': false
      },
      requireVerifyMap: {
        '需要实名': 'true',
        '无需实名': 'false',
        '跟随店铺设置': 'null',
      },
      randomOrderSwitchMap: {
        '可接随机单': true,
        '不可接随机单': false
      },
      updateMethodMap: null,
      picker: {
        show: false,
        columns: [],
        onConfirm: null,
        onCancel: null
      },
      clerkMap: new Map(),
      list: [],
      loading: false,
      finished: false,
      page: {
        no: 1,
        size: 10
      },
      iconAudio: require("../../../../assets/images/icon_audio.png"),
      iconAudioPlaying: require("../../../../assets/images/icon_audio_playing.gif"),
      player: {
        id: null,
        audio: null
      },
      activeNames: [1],
      initiateResign: {
        show: false,
      },
      clerkName: null,
      clerkId: null,
      message: null,
      radio: null,
    }
  },
  methods: {
    copyClick(shareLink) {
      let input = document.createElement("input");
      input.value = shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      Toast('复制成功');
    },
    qrcodeClick(id) {
      Toast.loading({
        mask: true,
        message: '生成中...'
      })
      shareInterface(id).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.promotionDialog.url = data.url
          this.promotionDialog.loge = data.loge
          this.promotionDialog.key++
          this.promotionDialog.show = true
        } else {
          Dialog.alert({
            title: '生成失败',
            message: data.msg
          })
        }
      })
    },
    initiateResignTest(id,name) {
      this.message = null;
      this.radio = null;
      this.clerkName = name;
      this.clerkId = id;

      this.initiateResign.show = true;
    },
    showConfirmButton(action,done){
      if (action == 'confirm'){
        if (this.radio === null || this.radio === 'null'){
          Dialog.alert({
            title: '离职类型不能为空',
          })
          done()
          return
        }
        if (!this.message){
          Dialog.alert({
            title: '离职原因不能为空',
          })
          done()
          return;
        }
        this .radio = this.radio === 1 ? true : false;
        addClerkResign(this.clerkId,this.radio,this.message).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: '操作成功',
            })
            this.onLoad(true)
            done()
          } else {
            Dialog.alert({
              title: '操作失败',
              message: data.msg
            })
          }
        })
      }else{
        done()
      }
    },
    mapEnumToColumn(Enum) {
      return _.map(Enum.list(), (elem) => {
        return elem.label
      })
    },
    openPicker(columns, onConfirm,onCancel) {
      this.picker.columns = columns
      this.picker.onConfirm = onConfirm
      if(!onCancel){
        onCancel = () => {
          onConfirm(null)
        }
      }
      this.picker.onCancel = onCancel;
      this.picker.show = true
    },
    onPickerConfirm(value) {
      if (this.picker.onConfirm) {
        this.picker.onConfirm(value)
      }
      this.picker.show = false
    },
    onPickerCancel(value) {
      if (this.picker.onCancel) {
        this.picker.onCancel(value)
      }
      this.picker.show = false
    },
    onUpdateRemarkDialogClose(action, done) {
      if (action == 'confirm') {
        updateClerkRemark(this.updateRemarkDialog.id,this.updateRemarkDialog.remark).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.list[this.updateRemarkDialog.index].remark=this.updateRemarkDialog.remark
            Toast('修改成功')
          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
        done()
      } else if (action === 'cancel') {
        done()
      }
    },
    clickRemark(index,remark,show,id){
      this.updateRemarkDialog.index=index;
      this.updateRemarkDialog.remark = remark;
      this.updateRemarkDialog.show = show;
      this.updateRemarkDialog.id = id;
    },
    formatTime(e) {
      return moment(e).format('YYYY-MM-DD HH:mm')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    mapGrade(grade){
      return (this._.invert(this.$store.state.ClerkGradeMap))[grade];
    },
    onLoad(resetPage) {
      this.activeNames = []
      this.loading = true
      let {
        id,
        name,
        sex,
        grade,
        group,
        status,
        isDisabled,
        isRecommend,
        isTop,
        isHide,
        isVerified,
        requireVerify,
        randomOrderSwitch,
        isFixGrade
      } = this.queryFormModel
      if (sex) {
        sex = this._.find(this.$store.state.ClerkSexEnum.list(), (elem) => {
          return elem.label === sex
        }).value;
      }
      if (grade) {
        grade = this.mapGrade(grade)
      }
      if (status) {
        status = this._.find(this.$store.state.ClerkStatusEnum.list(), (elem) => {
          return elem.label === status
        }).value;
      }
      if (isDisabled != null) {
        isDisabled = this.isDisabledMap[isDisabled]
      }
      if (isHide != null) {
        isHide = this.isHideMap[isHide]
      }
      if (isVerified != null) {
        isVerified = this.isVerifiedMap[isVerified]
      }
      if (requireVerify != null) {
        requireVerify = this.requireVerifyMap[requireVerify]
      }
      if (randomOrderSwitch != null) {
        randomOrderSwitch = this.randomOrderSwitchMap[randomOrderSwitch]
      }
      if (resetPage) {
        this.page.no = 1;
        this.list = []
      }
      listClerk(id, name, sex, grade, status, isDisabled, isRecommend ? true : null, isTop ? true : null, isHide,
          isVerified, requireVerify, randomOrderSwitch, isFixGrade ? true : null,
          this.page.no, this.page.size).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.code === 0) {
          if (!data.hasNext) {
            this.finished = true;
          } else {
            this.page.no++;
          }
          for (let i in data.list) {
            let clerk = data.list[i];
            this.list.push(clerk)
            this.clerkMap.set(clerk.id, clerk)
          }
        } else {
          Dialog.alert({
            title: '加载' + this.$store.state.label.clerkLabel + '失败',
            message: data.msg
          })
        }
      })
    },
    updateStatus(clerkId, key, value) {
      let vm = this;
      Dialog.confirm({
        title: '提示',
        message: '确认要修改吗？',
      }).then(() => {
            // on confirm
        let clerk = this.clerkMap.get(clerkId);
        Toast.clear()
        let promise = this.updateMethodMap.get(key)(clerkId,value);
        promise.then(res => {
          const data = res.data
          if (data.code === 0) {
            if(key === 'requireVerify'){
              if('false' === value){
                value = false;
              }else if('true' === value){
                value = true
              }else{
                value = null;
              }
            }else if(key === 'grade'){
              value = value+'';
            }else if(key === 'group'){
              key= 'groupName';
              value = vm.$store.state.ClerkGroupMap[value]
            }
            clerk[key] = value;
            Toast('修改成功')
          } else {
            Dialog.alert({
              title: '修改' + this.$store.state.label.clerkLabel + '状态失败',
              message: data.msg
            })
          }
        })
      }).catch(() => {
            // on cancel
      });

    },
    previewPhoto(photos, index) {
      ImagePreview({
        images: photos,
        startPosition: index
      })
    },
  },
  mounted() {
    let updateMethodMap = new Map();
    updateMethodMap.set('status',updateStatus)
    updateMethodMap.set('isDisabled',updateIsDisabled)
    updateMethodMap.set('isRecommend',updateIsRecommend)
    updateMethodMap.set('isHide',updateIsHide)
    updateMethodMap.set('isTop',updateIsTop)
    updateMethodMap.set('randomOrderSwitch',updateRandomOrderSwitch)
    updateMethodMap.set('requireVerify',updateRequireVerify)
    updateMethodMap.set('grade',updateGrade)
    updateMethodMap.set('isFixGrade',updateIsFixGrade)
    this.updateMethodMap = updateMethodMap;
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>
<style lang="less" scoped>
.page{
  line-height: 1;
  background: #f5f6f7;
  color: #333;
  font-size: 13px;
}

.option{
  margin-bottom: 7px;
  /deep/.van-cell__title{
    font-size: 15px
  }
}

.align-center{
  display: flex;
  align-items: center
}

.list{

  .listItem {
    padding: 17px 17px 13px 17px;
    background: #fff;
    margin-bottom: 7px;

    .clerkInfo {
      display: flex;
      margin-bottom: 14px;
    }

    .avatar {
      border-radius: 6px;
      width: 43px;
      height: 43px;
      margin-right: 9px;
    }

    .infoCore {
      flex: 1;

      .header {
        margin-bottom: 15px;

        .clerkName {
          color: #333333;
          font-weight: bold;
          font-size: 15px;
          margin-right: 15px;
        }

        .age-sex {
          color: #fff;
          padding: 3px 5px;
          display: flex;
          align-items: center;
          font-size: 11px;
          border-radius: 3px;
          margin-right: 8px;
        }

        .regionNames {
          font-size: 13px
        }

        .share {
          margin-left: auto;
          font-size: 15px
        }

        .isVerified {
          color: #808080;
          font-size: 13px;
          margin: 0 12px
        }

        .audio{
          background: #5892FF;
          border-radius: 4px;
          color: #fff;

          .van-button{
            height: initial;
            padding: 4px 6px;
            background: none;
            border: 0;
            color: #fff !important;
          }
        }
      }

      .signature {
        color: #808080;
        margin-bottom: 8px;
      }

      .tags {
        display: flex;
        align-items: center;
        color: #808080;
        margin-bottom: 14px;
      }

      .photos {
        display: flex;

        .photoItem {
          width: 43px;
          height: 43px;
          border-radius: 6px;
          margin-right: 4px;
        }
      }
    }

    .switchBox{
      display: flex;
      flex-wrap: wrap;
      border-bottom: 1px solid #F5F5F5;

      .switchItem{
        display: flex;
        align-items: center;
        width: 25%;
        margin-bottom: 10px;

        .label{
          white-space: nowrap;
          font-size: 12px;
          margin-left: 5px;
        }
      }
    }

    .remark{
      margin-top: 13px;
      display: flex;
      align-items: center;
    }

    .created{
      color: #999
    }
  }
}

.box{
  display: flex;
  margin-top: 15px;
  .title{
    width: 35%;
    text-align: center;
  }
  .right-box{
    flex: 1;
    overflow: hidden;
    .input-style{
      width: auto;
      border: 1px #999 solid;
      border-radius: 9px;
      margin: 0 15px 15px 0;
      overflow: hidden;
    }
  }
}

.qrbox {
  display: table;
  margin: 10px auto;
}

</style>
